import React from 'react';

export default function Versions() {
  return (
    <div>
      <div className="home-container small-width">
        <div className="container">
          <div className="body-text">
            Versions are alternate interpretations of the collection, rendered in different forms by the artist.
          </div>
        </div>
      </div>
    </div>
  );
};
